import React from "react";

const HowItWorks = () => {
  const workInfoData = [
    {
      image: `iphone-svgrepo-com.svg`,
      title: "Find something to earn from",
      text: "Choose from games, surveys, and offers matched to you.",
    },
    {
      image: `dollar-sign-money-bag-svgrepo-com.svg`,
      title: "Complete it",
      text: "Play, answer questions, or complete the offer.",
    },
    {
      image: `payment-svgrepo-com.svg`,
      title: "Get paid",
      text: "Earn RewardRocket cash and redeem for PayPal or gift cards.",
    },
  ];
  return (
    <div className="work-section-wrapper">
        <div className="about-background-image-container">
        <img src={`aboutbackground.png`} alt="" />
      </div>
      <div className="work-section-top">
        <p className="primary-subheading">Earn</p>
        <h1 className="primary-heading">How It Works</h1>
      </div>
      <div className="work-section-bottom">
        {workInfoData.map((data) => (
          <div className="work-section-info" key={data.title}>
            <div className="info-boxes-img-container">
              <img src={data.image} alt="" />
            </div>
            <h2>{data.title}</h2>
            <p>{data.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowItWorks;